/* ============================================================
   christina-layers.js — v4.1 (2026-08-04) — JEDEN KONTROLER WARSTW MOBILNYCH

   Zakres: dock, pasek ATC (sticky), banner cookies, kolumny nagłówka,
   klawiatura ekranowa, orientacja, placeholder braku zdjęcia.
   Jeden moduł, jedno źródło prawdy o stanie, JEDEN requestAnimationFrame.

   ─ Co zmienia v4.1 wobec v4.0 (trace R7 → R7a2) ────────────────────────
   v4.0 nadal była najdroższą funkcją strony na PDP mobile:
   `christina-layers.js::frame` = 155 ms self-time i 15 wymuszonych reflow.
   Cały ten koszt brał się z JEDNEJ linii w fazie odczytu:

       var r = cta.getBoundingClientRect();      // przy KAŻDYM zdarzeniu scroll

   `scroll` ustawiał bit J_SLOT, więc pomiar geometrii CTA szedł w każdej
   ramce przewijania, na layoucie brudnym po zapisach motywu i aplikacji.
   Czas synchronicznego layoutu jest w profilu doliczany do funkcji, która
   go wymusiła — stąd 155 ms w `frame`.

   v4.1:
   1. O widoczności CTA decyduje WYŁĄCZNIE IntersectionObserver.
      `entry.isIntersecting` przy `rootMargin: 0 0 -(slot+8) 0` jest
      dokładnym odpowiednikiem dawnego warunku `ctaBottom > 0 && ctaTop < vh
      - slot - 8`, tylko liczy go kompozytor, poza wątkiem głównym.
      Listener `scroll` USUNIĘTY — zero odczytów geometrii w pętli.
   2. Stan bannera cookies wynika ZE ZDARZEŃ komponentu, nie z pomiaru:
      motyw ustawia/zdejmuje atrybut `open` na `<cookie-banner>` i emituje
      bąbelkujące `modal:afterShow` / `modal:afterHide` (klasa ModalElement,
      `show()` → `setAttribute('open')`, `hide()` → `removeAttribute('open')`,
      `afterShow()` → `body.has-cookie-banner`). Do tego `visitorConsentCollected`
      i MutationObserver WYŁĄCZNIE na atrybutach tego jednego elementu.
      `getBoundingClientRect()` służy już tylko za awaryjną weryfikację
      w momencie ZMIANY stanu na „otwarty" — nigdy jako źródło.
      Zniknęły: `setInterval(500)` dozoru otwartego bannera, 12-sekundowy
      dozór startowy co 1 s i seria 4 timerów po kliknięciu w banner.
   3. `want(0)` nie planuje ramki — pusta maska bitowa nie ma czego zrobić,
      a v4.0 potrafiła zaplanować rAF wyłącznie po to, żeby stwierdzić `!todo`.
   4. Faza odczytu i faza zapisu rozdzielone twardo. Weryfikacja rect dla
      bannera też siedzi w fazie ODCZYTU, nie w `writeCookie`.
   5. `injectChatMenuItem()` usunięty. Pozycja „Czat z konsultantką"
      jest teraz STATYCZNYM markupem w `snippets/header-drawer.liquid`
      (klasa `cc-drawer-chat`, atrybut `data-cca-open`). v4.0 nie miała
      szans jej wstrzyknąć: od R6-W3 cała zawartość szuflady siedzi
      w `<template data-cb-lazy>`, więc `#MenuDrawer .drawer__menu` NIE
      ISTNIEJE w DOM aż do materializacji — `querySelector` zwracał null
      i poniżej 360 px nie było ŻADNEGO wejścia do czatu.
      Otwarcie czatu obsługuje delegacja w `christina-apps.js`
      (`closest('[data-cca-open]')`); tutaj zostaje tylko zamknięcie
      szuflady, żeby panel nie stanął na otwartym menu.

   ─ Zasady (bez zmian od v4.0) ──────────────────────────────────────────
   1. JEDEN rAF (`frame()`), zadania w masce bitowej. Nie ma drugiej pętli.
   2. W ramce najpierw KOMPLET ODCZYTÓW layoutu, potem KOMPLET ZAPISÓW.
   3. Zapis tylko przy realnej zmianie wartości (`setVar`, `__ccS`/`__ccE`).
   4. Bramkowanie po szablonie NA POZIOMIE INICJALIZACJI: logika slotu
      i cookies rejestruje się wyłącznie na `body.template-product`.
   5. Żaden `getComputedStyle` w ścieżce gorącej. `display:none`
      rozpoznajemy po `offsetHeight === 0`.
   6. Progi szerokości przez `matchMedia`, nie `innerWidth`.

   ─ Slot ────────────────────────────────────────────────────────────────
   `.mobile-dock` i `.christina-atf__sticky` zajmują na karcie produktu ten
   sam pas przy dole ekranu i są trzymane w ścisłej przeciwfazie — widoczny
   jest zawsze dokładnie jeden, nigdy oba, nigdy żaden.
   Rezerwa `--cc-slot-h` = MAX(dock, sticky), nie suma — przełączenie pasków
   nie rusza `body { padding-bottom }`, więc CLS = 0. Wysokości czytamy
   z `offsetHeight`, bo `getBoundingClientRect()` uwzględnia `translateY(110%)`
   ukrytego paska i dawałby zaniżony wynik.

   ─ Banner cookies (REGRESJA P0 Z RUNDY 5 — NIE POWTÓRZYĆ) ──────────────
   Pasek ATC chowamy tylko wtedy, gdy banner REALNIE zasłania dół ekranu,
   a w tym czasie slot przełączamy na dock. Selektor `:has(cookie-banner:
   not([hidden]))` pasował BEZ KOŃCA także po wyrażeniu zgody i zostawiał
   slot PUSTY na ~90 % długości PDP.
   Kierunek błędu w v4.1 jest bezpieczny w obie strony: nierozpoznane
   OTWARCIE zostawia widoczny pasek ATC (slot pełny), nierozpoznane
   ZAMKNIĘCIE zostawia widoczny dock (slot pełny). Pusty slot nie jest
   osiągalny, bo `cc-cookie-open` i tryb „dock" ustawia ta sama decyzja.

   ─ Kolumny nagłówka ────────────────────────────────────────────────────
   `.header` ma `grid-template-areas: "tools logo icons"`. Kolumny boczne
   wyliczały się WĘŻSZE niż zawartość (24 px przy grupie 44 px), bo
   `.header__buttons` ma ujemne marginesy `0 -10px`. Mierzymy realną
   szerokość grupy i podajemy ją do CSS jako `--cc-hdr-start` / `--cc-hdr-end`.
   ============================================================ */
(function () {
  'use strict';

  if (window.__ccLayers) return;          /* idempotencja: SPA, instant.page,
                                             ponowne wstrzyknięcie sekcji */
  window.__ccLayers = '4.1';

  var win = window;
  var root = document.documentElement;
  var DOCK = '.mobile-dock';
  var STICKY = '.christina-atf__sticky';
  var COOKIE = 'cookie-banner';
  var MAIN_CTA = '.christina-atf__form button[type="submit"], form[action*="/cart/add"] button[type="submit"]';

  function el(sel) { return document.querySelector(sel); }
  function bodyEl() { return document.body; }
  var IS_PDP = !!(document.body && document.body.classList.contains('template-product'));

  /* Progi szerokości przez matchMedia, nie `window.innerWidth`.
     Odczyt `innerWidth` wymusza w Blinku dociągnięcie layoutu, jeśli
     cokolwiek zdążyło go unieważnić. `matchMedia` czyta wyliczony stan
     media query i nic nie dociąga. */
  var MQ_HDR = win.matchMedia ? win.matchMedia('(max-width: 767px)') : null;
  function isNarrowHdr() { return MQ_HDR ? MQ_HDR.matches : win.innerWidth <= 767; }

  /* ============ JEDEN rAF ============ */
  var J_MEASURE = 1, J_SLOT = 2, J_HDR = 4, J_COOKIE = 8;
  var jobs = 0, rafId = null;

  /* pusta maska = brak zadania = NIE planujemy ramki.
     v4.0 wołała `want(IS_PDP ? J_SLOT : 0)` i na kolekcjach planowała rAF
     tylko po to, żeby `frame()` stwierdziło `!todo` i wyszło. */
  function want(bits) {
    if (!bits) return;
    jobs |= bits;
    if (rafId === null) rafId = win.requestAnimationFrame(frame);
  }

  /* stan — jedyne źródło prawdy */
  var st = {
    dockH: -1, stickyH: -1, slotH: 0,
    roDock: 0, roSticky: 0,     /* wysokości RAPORTOWANE przez ResizeObserver */
    cookieOpen: false,
    ctaSafe: null,          /* null = IO jeszcze nie odpowiedział */
    slotMode: null,
    hdrMobile: null,
    hdrDirty: true,         /* czy kolumny nagłówka wymagają ponownego pomiaru */
    keyboard: false
  };
  /* Gdy ResizeObserver jest dostępny, wysokości pasków przychodzą WYŁĄCZNIE
     z jego callbacku (po layoucie, za darmo) i `offsetHeight` nie jest wołane
     ANI RAZU. Pomiar startowy przez `offsetHeight` wymuszał PIERWSZY pełny
     layout dokumentu przed czasem: w trace R7a2 to jedno wywołanie `naturalH`
     kosztowało 30–60 ms (kolekcja, CPU 4×). `--cc-slot-h` ustawia się o jedną
     klatkę później, ale rezerwa dotyczy dołu dokumentu — nic widocznego się
     nie przesuwa, więc CLS zostaje zerowy. `naturalH` żyje dalej jako
     fallback dla przeglądarek bez ResizeObservera. */
  var RO_OK = (typeof ResizeObserver === 'function');

  /* zapis zmiennej CSS TYLKO przy realnej zmianie —
     każdy zapis na :root unieważnia layout całego dokumentu */
  function setVar(name, val) {
    if (root.style.getPropertyValue(name) === val) return false;
    root.style.setProperty(name, val);
    return true;
  }

  /* offsetHeight, nie getBoundingClientRect — transform ukrytego paska
     nie może zafałszować rezerwy. Zero getComputedStyle: paski są
     `position: fixed`, `display:none` daje offsetHeight === 0. */
  function naturalH(node) { return node ? (Math.round(node.offsetHeight) || 0) : 0; }

  function frame() {
    rafId = null;
    var todo = jobs; jobs = 0;
    if (!todo) return;

    /* ---------- FAZA ODCZYTU (żadnych zapisów poniżej tej sekcji) ---------- */
    var rd = {};
    /* wysokości pasków i wysokość okna czytamy WYŁĄCZNIE przy J_MEASURE
       (start, load, resize, orientacja, ResizeObserver na paskach).
       Przewijanie NIE dotyka layoutu w ogóle — decyduje IntersectionObserver. */
    if (todo & J_MEASURE) {
      /* UWAGA: tu NIE MA `win.innerHeight`. W Blinku odczyt `innerWidth`
         / `innerHeight` dociąga layout dokładnie tak samo jak `offsetHeight`
         — w trace R7a2 ta jedna linia odpowiadała za komplet 7 wymuszonych
         reflow przypisanych do `frame` i za ~140 ms jej self-time (czas
         synchronicznego layoutu księguje się na funkcji, która go wymusiła).
         Wysokość okna jest potrzebna wyłącznie do awaryjnej weryfikacji
         położenia bannera cookies i czytamy ją TAM, tuż po `getBoundingClientRect()`,
         czyli już na czystym layoucie — za darmo. */
      /* Wysokości pasków bierzemy z ResizeObservera (`borderBoxSize`), a nie
         z `offsetHeight`. RO podaje rozmiar z layoutu, który przeglądarka
         i tak policzyła — zero wymuszania. `offsetHeight` zostaje wyłącznie
         jako pomiar STARTOWY (zanim RO zdąży zaraportować) i jako fallback
         dla przeglądarek bez ResizeObservera. W trace R7a2 to właśnie te
         dwa `offsetHeight` odpowiadały za 7 wymuszonych reflow i lwią część
         143 ms self-time funkcji `frame` (V8 wtapia `naturalH` w `frame`,
         więc czas synchronicznego layoutu ląduje na jej koncie). */
      var nd = el(DOCK), ns = el(STICKY);
      rd.dockH = nd ? (RO_OK ? st.roDock : naturalH(nd)) : 0;
      rd.stickyH = ns ? (RO_OK ? st.roSticky : naturalH(ns)) : 0;
    }
    if (todo & J_COOKIE) rd.cookie = cookieRead();
    if (todo & J_SLOT) {
      /* zero geometrii: stan CTA pochodzi z IntersectionObservera.
         Sprawdzamy tylko, czy obserwowany węzeł nadal jest w dokumencie
         (wariant produktu / przerenderowana sekcja podmieniają przycisk). */
      rd.reobserve = IS_PDP && (!ioTarget || !ioTarget.isConnected);
    }
    /* `scrollWidth` też jest odczytem layoutu — mierzymy tylko wtedy, gdy coś
       naprawdę mogło zmienić szerokość grupy ikon (start, `load`, fonty,
       `resize`, obrót, przeładowanie sekcji), a nie przy każdym `settle`
       czy powrocie do karty. */
    if ((todo & J_HDR) && st.hdrDirty) rd.hdr = readHeaderTracks();

    /* ---------- FAZA ZAPISU (żadnych odczytów layoutu poniżej) ---------- */
    if (todo & J_MEASURE) writeMeasure(rd);
    if (todo & J_COOKIE) writeCookie(rd.cookie);
    if (todo & J_SLOT) {
      if (rd.reobserve) rebuildIO();
      writeSlot();
    }
    if ((todo & J_HDR) && rd.hdr) { st.hdrDirty = false; writeHeaderTracks(rd.hdr); }
  }

  /* unieważnienie pomiaru nagłówka + prośba o ramkę */
  function wantHdr() { st.hdrDirty = true; want(J_HDR); }

  /* ============ 1. REZERWA WYSOKOŚCI ============ */
  function writeMeasure(rd) {
    /* przy otwartej klawiaturze paski są `visibility:hidden`; nie zerujemy
       rezerwy na stałe, tylko czekamy aż klawiatura zniknie */
    if (st.keyboard) return;
    if (rd.dockH === st.dockH && rd.stickyH === st.stickyH) return;
    st.dockH = rd.dockH; st.stickyH = rd.stickyH;
    st.slotH = IS_PDP ? Math.max(rd.dockH, rd.stickyH) : (rd.dockH + rd.stickyH);
    if (setVar('--cc-slot-h', st.slotH + 'px') && IS_PDP) {
      rebuildIO();          /* rootMargin zależy od wysokości slotu */
      want(J_SLOT);         /* zmiana padding-bottom przesuwa CTA */
    }
  }

  /* ============ 2. BANNER COOKIES (tylko PDP) ============
     ŹRÓDŁO STANU = ATRYBUT, nie pomiar. Motyw (ModalElement):
       show() → setAttribute('open')  → afterShow  → body.has-cookie-banner
       hide() → removeAttribute('open') → afterHide → body bez klasy
     Oba zdarzenia (`modal:afterShow` / `modal:afterHide`) bąbelkują do
     dokumentu, więc łapiemy je bez względu na to, kiedy element trafi do DOM. */
  function cookieRead() {
    var cb = el(COOKIE);
    if (!cb) return false;
    var guess = cb.hasAttribute('open') || bodyEl().classList.contains('has-cookie-banner');
    if (cb.hasAttribute('hidden')) guess = false;
    /* AWARYJNA weryfikacja geometrią — wyłącznie przy ZMIANIE stanu na
       „otwarty" i wyłącznie tutaj, w fazie odczytu. Chroni przed sytuacją,
       w której atrybut `open` wisi, a banner jest poza ekranem. */
    if (guess && guess !== st.cookieOpen) {
      var inner = cb.querySelector('.drawer__inner') || cb;
      var r = inner.getBoundingClientRect();
      /* `innerHeight` DOPIERO TERAZ — layout jest już policzony przez rect
         powyżej, więc ten odczyt nic nie wymusza */
      if (r.width < 8 || r.height < 8) guess = false;
      else if (r.bottom <= 0 || r.top >= win.innerHeight) guess = false;
    }
    return guess;
  }

  function writeCookie(open) {
    if (open === st.cookieOpen) return;
    st.cookieOpen = open;
    bodyEl().classList.toggle('cc-cookie-open', open);
    want(J_MEASURE | J_SLOT);
  }

  /* ============ 3. SLOT ============ */
  function focusRescue(fromEl, toEl) {
    if (!fromEl || !document.activeElement) return;
    if (!fromEl.contains(document.activeElement)) return;   /* gorąca ścieżka kończy się TUTAJ */
    if (toEl && toEl.offsetParent !== null && typeof toEl.focus === 'function') {
      try { toEl.focus({ preventScroll: true }); return; } catch (e) {}
    }
    try {
      var b = bodyEl();
      if (!b.hasAttribute('tabindex')) b.setAttribute('tabindex', '-1');
      b.focus({ preventScroll: true });
    } catch (e) {}
  }

  function writeSlot() {
    var dock = el(DOCK), sticky = el(STICKY);
    if (!IS_PDP || !sticky || !ioTarget) {
      if (dock) { dock.classList.remove('cc-slot--off'); dock.removeAttribute('aria-hidden'); }
      st.slotMode = null;
      return;
    }
    /* `ctaSafe === false` = CTA wyszło poza bezpieczny viewport (IntersectionObserver
       z rootMargin -(slot+8)). `null` = obserwator jeszcze nie odpowiedział — wtedy
       zostaje stan startowy, czyli dock (góra strony). */
    var mode = (st.ctaSafe === false) ? 'sticky' : 'dock';
    /* pasek ATC schowany przez CSS (landscape / niskie okno) — slot NIGDY
       nie może zostać pusty, więc wracamy do docka. */
    if (st.stickyH === 0) mode = 'dock';
    /* ten sam powód dla bannera cookies: dopóki banner realnie zasłania dół
       ekranu, CSS trzyma pasek ATC poza ekranem */
    if (st.cookieOpen) mode = 'dock';

    if (mode === st.slotMode) return;
    st.slotMode = mode;

    if (mode === 'sticky') {
      focusRescue(dock, sticky.querySelector('[data-atf-atc]') || sticky.querySelector('button[type="submit"]'));
      sticky.classList.remove('christina-atf__sticky--hidden');
      sticky.removeAttribute('aria-hidden');
      if (dock) { dock.classList.add('cc-slot--off'); dock.setAttribute('aria-hidden', 'true'); }
    } else {
      focusRescue(sticky, el(MAIN_CTA));
      if (dock) { dock.classList.remove('cc-slot--off'); dock.removeAttribute('aria-hidden'); }
      sticky.classList.add('christina-atf__sticky--hidden');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  /* JEDEN IntersectionObserver = jedyne źródło wiedzy o położeniu CTA.
     `isIntersecting` przy rootMargin `0 0 -(slot+8) 0` jest równoważne
     dawnemu `rect.bottom > 0 && rect.top < vh - slot - 8`. */
  var io = null, ioTarget = null;
  function rebuildIO() {
    if (!IS_PDP) return;
    var cta = el(MAIN_CTA);
    if (io) { io.disconnect(); io = null; }
    ioTarget = cta || null;
    if (!cta || typeof IntersectionObserver !== 'function') return;
    try {
      io = new IntersectionObserver(function onCta(entries) {
        var vis = !!entries[entries.length - 1].isIntersecting;
        if (vis === st.ctaSafe) return;        /* brak zmiany = brak ramki */
        st.ctaSafe = vis;
        want(J_SLOT);
      }, {
        root: null,
        rootMargin: '0px 0px -' + (st.slotH + 8) + 'px 0px',
        threshold: 0
      });
      io.observe(cta);
    } catch (e) { st.ctaSafe = true; want(J_SLOT); }
  }

  /* ============ 4. KOLUMNY NAGŁÓWKA ============
     `scrollWidth` grupy ikon czytamy w callbacku ResizeObservera, czyli PO
     przeliczeniu layoutu przez przeglądarkę — taki odczyt nic nie wymusza.
     `frame()` dostaje gotową liczbę z `__ccW`. Zapis (`--cc-hdr-*`) idzie
     dopiero w ramce, nie w callbacku RO — inaczej Chrome zgłasza
     „ResizeObserver loop completed with undelivered notifications". */
  /* -1 = RO jeszcze nie zaraportował. NIE sięgamy wtedy po `scrollWidth`,
     bo to wymuszony layout w fazie odczytu ramki (w trace R7a2: 26 ms
     i 2 reflow). Czekamy na callback RO — do tego czasu obowiązują wartości
     domyślne z CSS (`44px` / `132px`), czyli dokładnie to, co widzi
     użytkownik przed uruchomieniem skryptu. */
  function grupaW(n) {
    if (!n) return 0;
    if (typeof n.__ccW === 'number') return n.__ccW;
    return roH ? -1 : n.scrollWidth;          /* fallback tylko bez ResizeObservera */
  }
  function readHeaderTracks() {
    if (!isNarrowHdr()) return (st.hdrMobile === false) ? null : { clear: true };
    var out = [], hs = document.querySelectorAll('.header');
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i];
      var s = grupaW(h.querySelector('.header__icons--start .header__buttons'));
      var e = grupaW(h.querySelector('.header__icons--end .header__buttons'));
      if (s < 0 || e < 0) return null;        /* pomiar jeszcze nie gotowy */
      out.push({ h: h, s: s, e: e });
    }
    return { list: out };
  }
  function writeHeaderTracks(data) {
    if (!data) return;
    if (data.clear) {
      st.hdrMobile = false;
      var hs = document.querySelectorAll('.header');
      for (var i = 0; i < hs.length; i++) {
        hs[i].style.removeProperty('--cc-hdr-start');
        hs[i].style.removeProperty('--cc-hdr-end');
        hs[i].__ccS = hs[i].__ccE = null;
      }
      return;
    }
    st.hdrMobile = true;
    data.list.forEach(function (o) {
      if (o.s > 0) {
        var v = Math.ceil(Math.max(44, o.s)) + 'px';
        if (o.h.__ccS !== v) { o.h.style.setProperty('--cc-hdr-start', v); o.h.__ccS = v; }
      }
      if (o.e > 0) {
        var w = Math.ceil(Math.max(44, o.e)) + 'px';
        if (o.h.__ccE !== w) { o.h.style.setProperty('--cc-hdr-end', w); o.h.__ccE = w; }
      }
    });
  }

  /* ============ 5. PLACEHOLDER BRAKU ZDJĘCIA ============ */
  function fixPlaceholders() {
    var lang = (root.lang || 'pl').slice(0, 2).toLowerCase();
    var label = lang === 'en' ? 'Product photo coming soon'
      : (lang === 'zh' ? '產品照片準備中' : 'Zdjęcie produktu w przygotowaniu');
    var nodes = document.querySelectorAll('.christina-atf__stage, .product-card__media');
    for (var i = 0; i < nodes.length; i++) {
      var h = nodes[i];
      if (h.__ccPh) continue;
      var svg = h.querySelector('svg.placeholder-svg, svg[class*="placeholder"]');
      if (!svg) { h.__ccPh = 1; continue; }        /* karty ze zdjęciem znakujemy,
                                                     żeby nie skanować ich ponownie */
      h.__ccPh = 1;
      h.classList.add('cc-no-photo');
      h.setAttribute('role', 'img');
      h.setAttribute('aria-label', label);
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    }
  }

  /* ============ 6. KLAWIATURA EKRANOWA ============
     Wykrywanie po visualViewport + activeElement, nigdy po samym resize —
     obrót ekranu i pasek adresu też zmieniają wysokość okna. */
  function isTextField(t) {
    if (!t) return false;
    if (t.isContentEditable || t.tagName === 'TEXTAREA') return true;
    if (t.tagName !== 'INPUT') return false;
    return !/^(checkbox|radio|button|submit|reset|range|file|image|color|hidden)$/i.test(t.type || '');
  }
  function setKeyboard(open) {
    if (open === st.keyboard) return;
    st.keyboard = open;
    bodyEl().classList.toggle('cc-keyboard-open', open);
    if (!open) want(J_MEASURE | J_SLOT);
  }

  /* ============ BOOTSTRAP ============ */
  var settleA = null, settleB = null;
  function settle() {
    win.clearTimeout(settleA); win.clearTimeout(settleB);
    settleA = win.setTimeout(function settleTickA() { want(J_MEASURE | J_SLOT | J_HDR); }, 320);
    settleB = win.setTimeout(function settleTickB() { want(J_MEASURE | J_SLOT); }, 900);
  }

  function boot() {
    st.hdrDirty = true;
    want(J_MEASURE | J_HDR | (IS_PDP ? (J_SLOT | J_COOKIE) : 0));
    fixPlaceholders();
    settle();
  }

  boot();

  win.addEventListener('load', function onLoad() {
    boot();
    observeBars(); observeHdr(); armGrids();
    if (IS_PDP) { rebuildIO(); attachCookieObs(); }
    win.setTimeout(function poLoad() { fixPlaceholders(); armGrids(); }, 1500);
    win.setTimeout(function poLoad2() { fixPlaceholders(); armGrids(); }, 3200);
  });

  /* bfcache — po powrocie z historii layout bywa przeliczony inaczej */
  win.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    st.dockH = st.stickyH = -1; st.slotMode = null; st.ctaSafe = null;
    if (IS_PDP) rebuildIO();
    st.hdrDirty = true;
    want(J_MEASURE | J_HDR | (IS_PDP ? (J_SLOT | J_COOKIE) : 0));
  });

  document.addEventListener('visibilitychange', function onVisibility() {
    if (document.visibilityState === 'visible') want(J_MEASURE | J_SLOT | J_HDR);
  });

  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(function () { wantHdr(); want(J_MEASURE); });
  }

  /* sekcje Shopify: nowy DOM = nowe wysokości, nowe karty, nowy przycisk CTA */
  document.addEventListener('shopify:section:load', function onSectionLoad() {
    fixPlaceholders();
    armGrids();
    if (IS_PDP) { rebuildIO(); attachCookieObs(); }
    observeBars();
    observeHdr();
    st.hdrDirty = true;
    want(J_MEASURE | J_HDR | (IS_PDP ? (J_SLOT | J_COOKIE) : 0));
    settle();
  });
  document.addEventListener('shopify:section:unload', settle);

  /* ResizeObserver: tylko na paskach slotu. Callback nie tylko odkłada zadanie —
     PODAJE gotową wysokość border-boxa z layoutu, który przeglądarka już
     policzyła. Dzięki temu `frame()` nie musi wołać `offsetHeight`.
     `borderBoxSize` ≙ `offsetHeight` (transform `translateY(110%)` ukrytego
     paska nie wpływa na border box — dokładnie o to chodzi w rezerwie). */
  var ro = null;
  function observeBars() {
    if (!ro) return;
    [DOCK, STICKY].forEach(function (sel) {
      var node = el(sel);
      if (node && !node.__ccObserved) { node.__ccObserved = 1; ro.observe(node); }
    });
  }
  try {
    ro = new ResizeObserver(function roBars(entries) {
      var zmiana = false;
      for (var i = 0; i < entries.length; i++) {
        var en = entries[i];
        var h = (en.borderBoxSize && en.borderBoxSize.length)
          ? Math.round(en.borderBoxSize[0].blockSize)
          : Math.round(en.contentRect.height);
        if (en.target.classList.contains('mobile-dock')) {
          if (st.roDock !== h) { st.roDock = h; zmiana = true; }
        } else {
          if (st.roSticky !== h) { st.roSticky = h; zmiana = true; }
        }
      }
      if (zmiana) want(J_MEASURE | (IS_PDP ? J_SLOT : 0));
    });
    observeBars();
  } catch (e) { ro = null; }

  /* RO na grupach ikon nagłówka — jedyne miejsce, w którym czytamy `scrollWidth` */
  var roH = null;
  function observeHdr() {
    if (!roH) return;
    var g = document.querySelectorAll('.header__icons--start .header__buttons, .header__icons--end .header__buttons');
    for (var i = 0; i < g.length; i++) {
      if (!g[i].__ccHdrObs) { g[i].__ccHdrObs = 1; roH.observe(g[i]); }
    }
  }
  try {
    roH = new ResizeObserver(function roHdr(entries) {
      var zmiana = false;
      for (var i = 0; i < entries.length; i++) {
        var n = entries[i].target;
        var w = n.scrollWidth;                 /* po layoucie — za darmo */
        if (n.__ccW !== w) { n.__ccW = w; zmiana = true; }
      }
      if (zmiana) wantHdr();
    });
    observeHdr();
  } catch (e) { roH = null; }

  /* MutationObserver: callback NIE liczy niczego, tylko odkłada zadanie.
     PODPINANY DOPIERO PO `load` i odpinany 3 s później. Podczas budowania
     strony mutacji są tysiące, a samo wejście w callback (nawet z pustym
     ciałem) kosztowało na kolekcji ~60 ms przy CPU 4×. Karty istniejące
     w chwili `load` obsługuje `fixPlaceholders()` z `boot()`; obserwator
     jest tylko po to, żeby złapać treść dokładaną PÓŹNIEJ (aplikacje,
     doładowanie siatki). */
  var mo = null, moT = null;
  try {
    mo = new MutationObserver(function moTick() {
      if (moT) return;
      moT = win.setTimeout(function moFlush() { moT = null; fixPlaceholders(); armGrids(); }, 400);
    });
  } catch (e) { mo = null; }

  /* Obserwujemy KONTENERY siatki (`childList` BEZ `subtree`), a nie całe
     `#MainContent` z poddrzewem. Kafle dokładają się wyłącznie jako dzieci
     listy — filtrowanie, doładowanie, rekomendacje — więc callback wchodzi
     kilka razy zamiast kilku tysięcy. */
  function armGrids() {
    if (!mo) return;
    var karty = document.querySelectorAll('.product-card');
    for (var i = 0; i < karty.length; i++) {
      var p = karty[i].parentElement;
      if (!p) continue;
      var lista = (p.parentElement && /^(UL|OL)$/.test(p.parentElement.tagName)) ? p.parentElement : p;
      if (!lista.__ccGridObs) { lista.__ccGridObs = 1; try { mo.observe(lista, { childList: true }); } catch (e) {} }
    }
  }
  armGrids();

  /* rozmiar okna — JEDEN listener na `resize` dla całej warstwy */
  var rzT = null;
  win.addEventListener('resize', function onResize() {
    setKeyboard(false);
    st.hdrDirty = true;
    want(J_MEASURE | J_HDR | (IS_PDP ? J_SLOT : 0));
    win.clearTimeout(rzT);
    rzT = win.setTimeout(function () {
      st.hdrDirty = true;
      want(J_MEASURE | J_HDR | (IS_PDP ? J_SLOT : 0));
      if (IS_PDP) rebuildIO();
    }, 260);
  }, { passive: true });

  win.addEventListener('orientationchange', function () {
    win.setTimeout(function () {
      setKeyboard(false);
      st.hdrDirty = true;
      want(J_MEASURE | J_HDR | (IS_PDP ? J_SLOT : 0));
      if (IS_PDP) rebuildIO();
    }, 250);
  });

  /* ============ WEJŚCIE DO CZATU W SZUFLADZIE MENU (< 360 px) ============
     Markup jest statyczny (snippets/header-drawer.liquid), otwarcie panelu
     robi delegacja w christina-apps.js po `[data-cca-open]`. Tutaj zostaje
     jedyna brakująca rzecz: zamknięcie szuflady, żeby panel czatu nie stanął
     na otwartym menu i nie walczył o pułapkę fokusu. Zero odczytów layoutu. */
  document.addEventListener('click', function onChatItemClick(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.cc-drawer-chat__btn')) return;
    var md = document.getElementById('MenuDrawer');
    if (md && typeof md.hide === 'function') { try { md.hide(); } catch (err) {} }
  }, true);

  /* ---------- rejestracja zależna od szablonu ---------- */
  /* Uwaga: na kolekcjach NIE rejestrujemy ani `scroll`, ani niczego wokół
     cookies. Na PDP `scroll` też już nie jest potrzebny — decyduje IO. */
  function attachCookieObs() {
    var cb = el(COOKIE);
    if (!cb || cb.__ccObs) return;
    cb.__ccObs = 1;
    try {
      /* WYŁĄCZNIE atrybuty tego jednego elementu. Bez childList, bez subtree —
         v4.0 obserwowała całe wnętrze bannera i budziła się na każdej
         mikro-zmianie w jego treści. */
      new MutationObserver(function moCookie() { want(J_COOKIE); }).observe(cb, {
        attributes: true,
        attributeFilter: ['open', 'hidden', 'class', 'style', 'inert']
      });
    } catch (e) {}
  }

  if (IS_PDP) {
    attachCookieObs();

    /* zdarzenia komponentu — bąbelkują, więc działają także wtedy, gdy
       `<cookie-banner>` trafia do DOM dopiero po starcie skryptu */
    document.addEventListener('modal:afterShow', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'COOKIE-BANNER') return;
      attachCookieObs(); want(J_COOKIE);
    });
    document.addEventListener('modal:afterHide', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'COOKIE-BANNER') return;
      want(J_COOKIE);
    });
    /* Shopify Customer Privacy API — zgoda zebrana = banner zaraz zniknie */
    document.addEventListener('visitorConsentCollected', function () { want(J_COOKIE); });
    document.addEventListener('trackingConsentAccepted', function () { want(J_COOKIE); });
  }

  var vv = win.visualViewport;
  if (vv) {
    var baseline = vv.height;
    /* `visualViewport.scroll` leci przy KAŻDYM przewinięciu, a `vv.height`
       jest odczytem layoutu — w trace R7 `onVV` odpowiadało za 4 wymuszone
       reflow na kolekcji. Klawiatura ekranowa może być otwarta wyłącznie
       wtedy, gdy fokus siedzi w polu tekstowym; sprawdzamy to NAJPIERW,
       bo `activeElement` i `tagName` nie dotykają layoutu. */
    var onVV = function () {
      if (!st.keyboard && !isTextField(document.activeElement)) return;
      if (vv.height > baseline) baseline = vv.height;
      setKeyboard((baseline - vv.height) > 150 && isTextField(document.activeElement));
    };
    /* TYLKO `resize`. Dawny `vv.scroll` leciał przy każdym przewinięciu strony
       i był jedynym listenerem `scroll` rejestrowanym przez ten plik poza PDP.
       Klawiatura ekranowa zmienia WYSOKOŚĆ visual viewportu, więc `resize`
       w zupełności wystarczy (Android i iOS). */
    vv.addEventListener('resize', onVV, { passive: true });
    document.addEventListener('focusout', function () { win.setTimeout(onVV, 200); });
  } else {
    document.addEventListener('focusin', function (e) {
      if (win.innerWidth <= 859 && isTextField(e.target)) setKeyboard(true);
    });
    document.addEventListener('focusout', function () {
      win.setTimeout(function () { setKeyboard(false); }, 150);
    });
  }
})();
